import Button from '@UI/New/Button';
import s from '../index.module.css';
import classes from './index.module.css';
import { useEffect, useState, ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { useAddAlert } from '@/hooks/useAddAlert';
import { ExelIcon } from '@/utils/icons';
import UploadFile from '@UI/UploadFile';
import { API } from '@/api';
import { closeAllModal } from '@store/modalsSlise';
import { useDownloadFile } from '@/hooks/useDownloadFile';

interface DownloadParams {
  api: string;
  name: string;
  title: string;
}

interface SaveParams {
  api: string;
}

interface BulkUploadData {
  title: string;
  description: ReactNode;
  downloadParems: DownloadParams;
  saveParems: SaveParams;
}

interface BulkUploadProps {
  data: BulkUploadData;
}

const BulkUpload: React.FC<BulkUploadProps> = ({
  data
}) => {
    const addAlert = useAddAlert();
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);

    const [file, setFile] = useState('');
    const handleCloseAllModal = () => {
        dispatch(closeAllModal());
    };
    
    const { download, loading } = useDownloadFile();
  
    const save = () => {
        if (!file) {
            addAlert({title: 'Ошибка', text: 'Пожалуйста, выберите файл.', type: 'error' });
            return;
        }
        if (saving) return

        setSaving(true);

        const formData = new FormData();
        formData.append("exel", file);

        API.post(data.saveParems.api, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then((res) => {
            if (!res.status || res.status < 200 || res.status >= 300)
                throw new Error()

            addAlert({ text: 'Файл успешно загружен и обработан.', type: 'success' });
            setFile('');
            handleCloseAllModal();
        })
        .catch(error => {
            const errorMessage = error?.response?.data?.error?.[0] || 'Ошибка при загрузке файла.';
            addAlert({ text: errorMessage, type: 'error' });
            console.error("File upload error: ", error);
        })
        .finally(() => {
            setSaving(false);
        });
    }

    
  return (
      <div className={classNames(s.modalContainer, classes.modalContainer)}>
          <div className={s.modalHeader}>
            <div className={s.modalTitleContainer}>
              <span className={s.modalHeaderBigTitle}>
                {data.title}
              </span>
            </div>
          </div>
          <div className={classNames(s.contentWrapper, classes.contentWrapper)}>
            <div className={s.description}>
              {data.description} 
            </div>
            <Button
              className={classes.button}
              color="gray"
              onClick={() => download({api: data.downloadParems.api, name: data.downloadParems.name})}
              disabled={loading}
              isLoading={loading}
              rightContent={
                <ExelIcon />
              }
            >
                  {data.downloadParems.title}
            </Button>
            <UploadFile
                className={classes.file} 
                value={file} 
                title='Выерите файл'
                onChange={val => setFile(val) }
                accept={"image/*"}
            />
            <Button
              className={classes.button}
              color="primary"
              onClick={save}
              disabled={saving}
              isLoading={saving}
            >
                  Сохранить
            </Button>
          </div>
      </div>
  )
}


export default BulkUpload
